import { Box, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";

const allImages = [
  require("../../assets/theme/back-embroidery-oversized-black-hoodie.jpg"),
  require("../../assets/theme/887b760f526b95e94836842d788d5f0c.jpg"),
  require("../../assets/theme/a8b7dbbf3446d5d3b94e69afdd6282a6.jpg"),
  require("../../assets/theme/Thick-Stand-Up-Collar-Puffer-Jacket-WN3915-3.webp"),
  require("../../assets/theme/O1CN01x912QE1VQphQnj3hh__2434502648.webp"),
  require("../../assets/theme/batch_O1CN01cX6Tbu1tTcvCxrJZL__2207247655903.webp"),
  require("../../assets/theme/31_4b285f4d-f5c7-4844-a0eb-86744d2afcb9.webp"),
  require("../../assets/theme/09_e60dee2e-c689-4e8b-be75-b9691419bbe9.webp"),
];

const heroTitles = [
  "Best Sellers",
  "New Collection",
  "Trendy Looks",
  "Winter Jackets",
  "Street Style",
  "Classic Black",
  "New style",
];

function getRandomIndices(count, max, exclude = []) {
  const indices = [];
  while (indices.length < count) {
    const idx = Math.floor(Math.random() * max);
    if (!indices.includes(idx) && !exclude.includes(idx)) {
      indices.push(idx);
    }
  }
  return indices;
}

const HeroPanels = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(min-width:601px) and (max-width:900px)");
  const isDesktop = useMediaQuery("(min-width:901px)");
  let panelCount = 3;
  if (isMobile) panelCount = 1;
  else if (isTablet) panelCount = 2;
  const [panelIndices, setPanelIndices] = useState(() =>
    getRandomIndices(panelCount, allImages.length)
  );
  const intervalRef = useRef();

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setPanelIndices((prev) => {
        // Pick a random panel to replace
        const replaceIdx = Math.floor(Math.random() * panelCount);
        // Get available images not currently shown
        const available = allImages
          .map((_, i) => i)
          .filter((i) => !prev.includes(i));
        if (available.length === 0) return prev; // nothing to swap
        const newIdx = available[Math.floor(Math.random() * available.length)];
        const next = [...prev];
        next[replaceIdx] = newIdx;
        return next;
      });
    }, 5000);
    return () => clearInterval(intervalRef.current);
  }, [panelCount]);

  // Update panelIndices if panelCount changes (e.g., resize)
  useEffect(() => {
    setPanelIndices(getRandomIndices(panelCount, allImages.length));
  }, [panelCount]);

  return (
    <Box
      display="flex"
      width="100vw"
      height="100vh"
      minHeight="600px"
      overflow="hidden"
      sx={{
        position: "relative",
        pt: { xs: "100px", sm: "60px" },
        // xs applies to mobile, sm and up to tablet/desktop
      }}
    >
      {panelIndices.map((imgIdx, i) => (
        <Box
          key={i}
          flex={1}
          position="relative"
          minWidth={0}
          height="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{ background: "none" }}
        >
          <img
            src={allImages[imgIdx]}
            alt={heroTitles[imgIdx % heroTitles.length]}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: 1,
            }}
          />
          <Box
            position="relative"
            zIndex={2}
            width="100%"
            height="100%"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
          >
            <Typography
              variant="h2"
              fontWeight={900}
              sx={{
                fontFamily:
                  "MSCHFSansMono, monospace, Arial, Helvetica, sans-serif",
                color: "#f5f5f5",
                textShadow: "0 2px 8px rgba(0,0,0,0.18), 0 1px 0 #222",
                letterSpacing: "0.18em",
                fontSize: { xs: "6vw", sm: "3vw", md: "2vw" },
                lineHeight: { xs: "5vw", sm: "3vw", md: "2.5vw" },
                textTransform: "uppercase",
                opacity: 0.97,
                userSelect: "none",
                textAlign: "center",
                whiteSpace: "pre-line",
                background: "rgba(24, 24, 24, 0.22)", // lighter, more transparent
                borderRadius: "10px", // less strict
                px: 2.5, // less padding
                py: 1.2,
                boxShadow: "0 2px 8px 0 rgba(0,0,0,0.10)",
                backdropFilter: "blur(2px)",
                // No border for a softer look
                transition: "background 0.3s, color 0.3s",
              }}
            >
              {heroTitles[imgIdx % heroTitles.length]}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default HeroPanels;
